import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import callApi from 'services/api'
import { loadingState } from 'global/LoaderState'
import { useRecoilState } from 'recoil'
import { AlertState } from 'global/AlertState'
import { LoginState } from 'global/LoginState'
import { useNavigate } from 'react-router-dom'
import { encryptByRSA } from 'utils/CryptoUtils'
const ChangePassword = () => {
  const navigate = useNavigate()
  const [, setloginState] = useRecoilState(LoginState)
  const [showold_password, setShowold_password] = useState(false)
  const [showpassword, setShowpassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showconfirm_password, setShowconfirm_password] = useState(false)
  const [, enableLoader] = useRecoilState(loadingState)
  const [, setAlertMessage] = useRecoilState(AlertState)

  const togglePasswordVisibility = (type) => {
    if (type === 'old') setShowold_password((prev) => !prev)
    if (type === 'new') setShowpassword((prev) => !prev)
    if (type === 'confirm') setShowconfirm_password((prev) => !prev)
  }

  const formik = useFormik({
    initialValues: {
      old_password: '',
      password: '',
      confirm_password: '',
    },
    validationSchema: Yup.object({
      old_password: Yup.string().required('Old password is required.'),
      password: Yup.string()
        .min(8, 'Password must be at least 8 characters.')
        .required('New password is required.'),
      confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match.')
        .required('Confirm password is required.'),
    }),
    onSubmit: async (values) => {
      enableLoader(true)
      setLoading(true)
      var response = await callApi(
        'auth/change-password',
        'POST',
        values,
        true,
        true,
        setAlertMessage,
        navigate
      )

      enableLoader(false)
      setLoading(false)
      if (response.success == true) {
        // localStorage.clear()
        setAlertMessage('Password changed successfully.Please login !|true')
        setloginState(false)
        navigate('/')
      }
    },
  })

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card mt-3">
            <div className="card-face card-front">
              <div className="card-body">
                <h3 className="card-title mb-3">Change Password</h3>
                <form onSubmit={formik.handleSubmit}>
                  {/* Old Password */}
                  <div className="mb-3">
                    <label htmlFor="old_password" className="form-label">
                      Old Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showold_password ? 'text' : 'password'}
                        id="old_password"
                        name="old_password"
                        className={`form-control ${
                          formik.touched.old_password &&
                          formik.errors.old_password
                            ? 'is-invalid'
                            : ''
                        }`}
                        {...formik.getFieldProps('old_password')}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => togglePasswordVisibility('old')}
                      >
                        {showold_password ? <FaEyeSlash /> : <FaEye />}
                      </button>
                      {formik.touched.old_password &&
                        formik.errors.old_password && (
                          <div className="invalid-feedback">
                            {formik.errors.old_password}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* New Password */}
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      New Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showpassword ? 'text' : 'password'}
                        id="password"
                        name="password"
                        className={`form-control ${
                          formik.touched.password && formik.errors.password
                            ? 'is-invalid'
                            : ''
                        }`}
                        {...formik.getFieldProps('password')}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => togglePasswordVisibility('new')}
                      >
                        {showpassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                      {formik.touched.password && formik.errors.password && (
                        <div className="invalid-feedback">
                          {formik.errors.password}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="mb-3">
                    <label htmlFor="confirm_password" className="form-label">
                      Confirm Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showconfirm_password ? 'text' : 'password'}
                        id="confirm_password"
                        name="confirm_password"
                        className={`form-control ${
                          formik.touched.confirm_password &&
                          formik.errors.confirm_password
                            ? 'is-invalid'
                            : ''
                        }`}
                        {...formik.getFieldProps('confirm_password')}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => togglePasswordVisibility('confirm')}
                      >
                        {showconfirm_password ? <FaEyeSlash /> : <FaEye />}
                      </button>
                      {formik.touched.confirm_password &&
                        formik.errors.confirm_password && (
                          <div className="invalid-feedback">
                            {formik.errors.confirm_password}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-info"
                      disabled={loading}
                    >
                      Change Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-2">
            <button
              type="button"
              className="btn btn-sm btn-secondary"
              onClick={() => navigate('/')}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ChangePassword
